import FItem from '.';
import { toString } from '@/utils/date';
import { toDate } from '@/utils/string';

export default class FItemDate extends FItem {
  constructor(props = {}) {
    super(props);
    this.min = props.min || new Date(1900, 0, 1);
    if (props.min) {
      this.setValidatorMin(props.min);
    }
    this.max = props.max || new Date(2100, 0, 1);
    if (props.max) {
      this.setValidatorMax(props.max);
    }
  }

  set(value = null) {
    super.set(value);
  }

  setValidatorMin(date, message = 'Неверная дата') {
    this.setValidator((value) => {
      if (value && value.getTime() < date.getTime()) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, false);
    return this;
  }

  setValidatorMax(date, message = 'Неверная дата') {
    this.setValidator((value) => {
      if (value && value.getTime() > date.getTime()) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, false);
    return this;
  }

  toString(mask = FItemDate.mask, value) {
    return toString(value || this.value, mask);
  }

  setString(date, mask = 'dd.MM.yyyy') {
    this.set(toDate(date, mask));
  }
}
